import PropTypes from 'prop-types'

const commonPropTypes = {
  elmId: PropTypes.string.isRequired,
  // value: PropTypes.string (Taking out until we figure out a better way to handle value prop within fields)
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  showError: PropTypes.bool,
  fluid: PropTypes.bool,
  hideWrapper: PropTypes.bool,
  focused: PropTypes.bool,
}

export default commonPropTypes
